// eslint-disable-next-line import/no-extraneous-dependencies
import { Buffer } from 'buffer/';

(<any>globalThis).Buffer = Buffer;
